export const experience = [
  {
    company: "Flipkart",
    role: "Software Development Engineer",
    start: "Nov 2024",
    end: "Present",
    bullets: [
      "Owned backend development for enabling picking of loose staples in dark stores within hyperlocal flow (Flipkart Minutes), driving solutioning, LLD, cross-team contract finalization, and integration across services while handling complex edge cases and distributed failure scenarios.",
      "Designed and implemented an IRT based stocktake flow, transitioning a manual, operations-heavy process into an automatic system-driven flow. Owned end-to-end delivery of feature from design and development to UAT and production rollout, eliminating manual intervention and deprecating legacy service dependency.",
      "Implemented backend APIs as part of the migration of non-customer outbound supply chain from a monolithic to microservices architecture and collaborated with cross-functional teams for finalizing API contracts and seamless integartion.",
      "Refactored critical backend APIs using object-oriented design principles and optimized database queries, improving maintainability, reducing latency, and ensuring stability under high traffic loads.",
      "Actively participated in UAT, debugged and resolved various production issues. Handled on-call incidents and deployed permanent fixes for recurring issues in business-critical flows, reducing operational noise and improving overall system stability.",
    ],
    tech: ["Java", "Spring Boot", "SQL", "Kubernetes"],
  },
  {
    company: "Emendo",
    role: "SDE Intern",
    start: "Jan 2024",
    end: "Oct 2024",
    bullets: [
      "Designed and implemented backend services for core features such as material management, invoicing, and estimates.",
      "Integrated Google Sheets with the material management system using the Google Sheets API to keep sheets and the database in sync.",
      "Migrated services from a NoSQL to SQL database, including schema design, data transformation, and service-layer changes.",
      "Implemented federated identity providers with AWS Cognito to deliver secure, standards-based user authentication.",
    ],
    tech: [
      "AWS Lambda",
      "RDS",
      "API Gateway",
      "Cognito",
      "DynamoDB",
      "S3",
      "SNS",
      "TypeScript",
      "Sequelize",
      "Node.js",
    ],
  },
];
